<span class="underline-on-hover" [hidden]="isHidden">
  @switch (property) {
    @case ('bom') {
      <span #fileType i18n="@@app.bom">BOM</span>
    }
    @case ('bom_with_price') {
      <span #fileType i18n="@@app.bom_with_price">BOM with price</span>
    }
    @case ('project_bom_with_price') {
      <span #fileType i18n="@@app.project_bom_with_price">Project BOM with price</span>
    }
    @case ('bom_without_price') {
      <span #fileType i18n="@@app.bom_without_price">BOM without price</span>
    }
    @case ('project_bom_without_price') {
      <span #fileType i18n="@@app.project_bom_without_price">Project BOM without price</span>
    }
    @case ('disposition_layout') {
      <span #fileType i18n="@@app.disposition_layout_without_covers">Disposition Layout without covers</span>
    }
    @case ('project_disposition_layout') {
      <span #fileType i18n="@@app.project_disposition_layout_without_covers">Project Disposition Layout without covers</span>
    }
    @case ('disposition_layout_with_covers') {
      <span #fileType i18n="@@app.disposition_layout_with_covers">Disposition Layout with covers</span>
    }
    @case ('project_disposition_layout_with_covers') {
      <span #fileType i18n="@@app.project_disposition_layout_with_covers">Project Disposition Layout with covers</span>
    }
    @case ('disposition_labels') {
      <span #fileType i18n="@@app.labels_frontside_print">Label document (frontside print)</span>
    }
    @case ('disposition_labels_backside') {
      <span #fileType i18n="@@app.labels_backside_print">Label document (backside print)</span>
    }
    @case ('enclosure_layout') {
      <span #fileType i18n="@@app.enclosure_layout">Enclosure Layout</span>
    }
    @case ('project_enclosure_layout') {
      <span #fileType i18n="@@app.project_enclosure_layout">Project Enclosure Layout</span>
    }
    @case ('enclosure_layout_w_covers') {
      <span #fileType i18n="@@app.enclosure_layout_w_covers">Enclosure Layout with covers</span>
    }
    @case ('rating_plate') {
      <span #fileType i18n="@@app.rating_plate">Rating Plate</span>
    }
    @case ('project_enclosure_layout_w_covers') {
      <span #fileType i18n="@@app.project_enclosure_layout_w_covers">Project Enclosure Layout with covers</span>
    }
    @case ('legends') {
      <span #fileType i18n="@@app.legends">Legends</span>
    }
    @case ('sld') {
      <span #fileType i18n="@@app.sld">SLD</span>
    }
    @case ('routine_verification_pdf') {
      <span #fileType i18n="@@app.routine_verification_document">Routine verification</span>
    }
    @case ('routine_verification_word') {
      <span #fileType i18n="@@app.routine_verification_document">Routine verification</span>
    }
    @default {
      <span>{{property}}</span>
    }
  }
  <ng-content></ng-content>
</span>
